import { ExactScopeName } from '~hooks/permissions/use-has-scope'
import { IUserInfoReadResponse } from '~hooks/queries/me/me-types'

export const dummyUserVt: IUserInfoReadResponse = {
  sub: 'auth0|123',
  email: 'johndoe@example.com',
  name: 'John Doe',
  ToSAcceptedDate: '2024-08-16T08:07:35.080Z',
  settings: {
    vessels: {
      favourites: [],
    },
    guidedTours: [
      {
        id: '2',
        status: 'Completed',
      },
    ],
  },
  scope: [
    'poolpartner:CID:user',
    'vessel:66ebfcaad043f6111ac0d57a:poolpartner',
    'vessel:G6B:poolpartner',
    ExactScopeName.maerskTankersUser,
    ExactScopeName.charteringUpdate,
    'settings:*:write',
  ],
  isInternal: true,
  poolPartnerKeys: ['CID'],
  activePools: ['MR'],
  profitCenterPools: ['Handy', 'LR2', 'MR'],
  favoriteVesselsNames: [],
}
